import { combineReducers } from 'redux';
import { chartReducer } from './chart';
import { familySearchReducer } from './family-search';
import { cellsReducer } from './cells';
import { uiReducer } from './ui';
import { palettesReducer } from './palettes';
import { generationsReducer } from './generations';
import { modalReducer } from './modal';

const rootReducer = combineReducers({
  chart: chartReducer,
  generations: generationsReducer,
  cells: cellsReducer,
  familySearch: familySearchReducer,
  ui: uiReducer,
  palettes: palettesReducer,
  modal: modalReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/core/reducer.js